import { render } from "./routeCreate.vue?vue&type=template&id=1803c9b0&scoped=true"
import script from "./routeCreate.vue?vue&type=script&lang=js"
export * from "./routeCreate.vue?vue&type=script&lang=js"

import "./routeCreate.vue?vue&type=style&index=0&id=1803c9b0&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1803c9b0"]])

export default __exports__